import { CampanyasService } from 'src/app/services/datos/campanyas.service';
import { Component, OnInit } from '@angular/core';
import { ChartData, ChartEvent, ChartType } from 'chart.js';

// Servicios
import { UbicacionesService } from 'src/app/services/datos/ubicaciones.service';
import { EntradasService } from 'src/app/services/datos/entradas.service';
import { AuxDataService } from 'src/app/services/datos/auxData.service';
import { NotificacionesService } from 'src/app/services/notificaciones.service';

@Component({
  selector: 'app-panel',
  templateUrl: './panel.component.html',
  styleUrls: ['./panel.component.css'],

})
export class PanelComponent implements OnInit {

  grafData: any[] = [];
  ubiData: any[] = [];
  campData: any[] = [];


  // Mostrar componentes si tiene contenido
  mostrarEntradasPendientes: boolean = false;
  mostrarPedidosPendientes: boolean = false;
  mostrarFragmentacionStock: boolean = false;

  // Totales para evolución 
  totalesServidos: number = 0;
  totalesIncidencias: number = 0;

  chartOptions = {
    responsive: true,
    animation: {
      duration: 0
    }
  };

  lineChartOptions: any = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        position: 'top',
        labels: {
          usePointStyle: true,
          padding: 20,
          font: {
            size: 12,
            weight: 'bold'
          }
        }
      },
      tooltip: {
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        titleColor: '#1e293b',
        bodyColor: '#334155',
        borderColor: 'rgba(0,0,0,0.1)',
        borderWidth: 1,
        padding: 12,
        titleFont: { size: 14, weight: 'bold' },
        bodyFont: { size: 13 },
        cornerRadius: 8,
        displayColors: true,
        usePointStyle: true,
        boxPadding: 6
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        grid: {
          color: 'rgba(0,0,0,0.05)'
        }
      },
      x: {
        grid: {
          display: false
        }
      }
    },
    elements: {
      line: {
        tension: 0.4, // Suavizado de curva
        borderWidth: 3
      },
      point: {
        radius: 4,
        hitRadius: 10,
        hoverRadius: 6
      }
    },
    interaction: {
      mode: 'index',
      intersect: false,
    },
  };

  chartServidosData: ChartData<'line'> | null = null;
  chartIncidenciasData: ChartData<'line'> | null = null;

  constructor(
    private ubicacionSrv: UbicacionesService,
    private campanyasSrv: CampanyasService,
    private auxDataSrv: AuxDataService,
    private entriesSrv: EntradasService,
    private notificSrv: NotificacionesService,
  ) { }

  ngOnInit(): void {
    this.ubicacionSrv.getTotalUbis().subscribe(resp => {
      this.ubiData = resp.data;
      console.log('__ubiData', this.ubiData);

      this.campanyasSrv.getTotPendientes().subscribe(resp => {
        this.campData = resp.data;
        console.log('__campData', this.campData);

        this.grafData = this.uneObjs()!;
        console.log('__grafData', this.grafData);
      })
    })

    this.getPedidosPorMes();
  }



  getChartData(item: any): ChartData {
    const ocupados = +item.ocupados;
    const disponibles = +item.totalAlmacen - ocupados;
    const colores = {
      'verdeBack': 'rgba(239,83,80, 0.8)',
      'verdeHover': 'rgba(239,83,80, 1)',
      'rojoBack': 'rgba(102,187,106, 0.8)',
      'rojoHover': 'rgba(102,187,106, 1)'
    }

    return {
      labels: ['Ocupado', 'Disponible'],
      datasets: [
        {
          data: [ocupados, disponibles],
          backgroundColor: [colores.verdeBack, colores.rojoBack],
          hoverBackgroundColor: [colores.verdeHover, colores.rojoHover]
        }
      ]
    };
  }



  getPedidosPorMes() {
    this.auxDataSrv.getPedidosPorMes().subscribe((resp) => {
      console.log('__getPedidosPorMes():', resp);

      if (resp.error) {
        this.notificSrv.aviso('error', resp.mensaje);
        return;
      }

      const labels = resp.data.meses;
      const valores = resp.data.valores;

      // Calcular totales acumulados (para los badges superiores)
      this.totalesServidos = 0;
      this.totalesIncidencias = 0;

      if (valores['Servido']) {
        this.totalesServidos += valores['Servido'].reduce((a: number, b: number) => a + b, 0);
      }
      if (valores['En proceso']) {
        this.totalesServidos += valores['En proceso'].reduce((a: number, b: number) => a + b, 0);
      }
      if (valores['Servido con faltas']) {
        this.totalesServidos += valores['Servido con faltas'].reduce((a: number, b: number) => a + b, 0);
      }

      if (valores['Cancelado']) {
        this.totalesIncidencias += valores['Cancelado'].reduce((a: number, b: number) => a + b, 0);
      }
      if (valores['Incidencia']) {
        this.totalesIncidencias += valores['Incidencia'].reduce((a: number, b: number) => a + b, 0);
      }

      // Gráfico 1: Servidos, En proceso y Servido con faltas 
      this.chartServidosData = {
        labels: [...labels],
        datasets: [
          {
            data: [...valores['Servido']],
            label: 'Servidos',
            borderColor: '#4caf50',
            backgroundColor: 'rgba(76, 175, 80, 0.1)',
            fill: true,
            pointBackgroundColor: '#4caf50',
            pointBorderColor: '#fff',
            tension: 0.4
          },
          {
            data: [...valores['En proceso']],
            label: 'En proceso',
            borderColor: '#2196f3',
            backgroundColor: 'rgba(33, 150, 243, 0.1)',
            fill: true,
            pointBackgroundColor: '#2196f3',
            pointBorderColor: '#fff',
            tension: 0.4
          },
          {
            data: [...valores['Servido con faltas']],
            label: 'Con faltas',
            borderColor: '#ff9800',
            backgroundColor: 'rgba(255, 152, 0, 0.1)',
            fill: true,
            pointBackgroundColor: '#ff9800',
            pointBorderColor: '#fff',
            tension: 0.4
          }
        ]
      };

      // Gráfico 2: Cancelados e Incidencias
      this.chartIncidenciasData = {
        labels: [...labels],
        datasets: [
          {
            data: [...valores['Cancelado']],
            label: 'Cancelados',
            borderColor: '#f44336',
            backgroundColor: 'rgba(244, 67, 54, 0.1)',
            fill: true,
            pointBackgroundColor: '#f44336',
            pointBorderColor: '#fff',
            tension: 0.4
          },
          {
            data: [...valores['Incidencia']],
            label: 'Incidencias',
            borderColor: '#9c27b0',
            backgroundColor: 'rgba(156, 39, 176, 0.1)',
            fill: true,
            pointBackgroundColor: '#9c27b0',
            pointBorderColor: '#fff',
            tension: 0.4
          }
        ]
      };
    });
  }




  public doughnutChartType: ChartType = 'doughnut';

  // events
  public chartClicked({ event, active }: { event?: ChartEvent, active?: {}[] }): void {
    console.log(event, active);
  }

  public chartHovered({ event, active }: { event?: ChartEvent, active?: {}[] }): void {
    console.log(event, active);
  }


  // Unir resultados de ubicaciones y campañas en un objeto:

  private uneObjs() {
    const resultado = this.ubiData.map(item => {
      const totalAlmacen = item.totalAlmacen;
      const ocupados = item.ocupados;
      const libres = totalAlmacen - ocupados;

      const updatedItem = {
        ...item,
        porcentajeLibres: (libres / totalAlmacen) * 100,
        porcentajeOcupadas: (ocupados / totalAlmacen) * 100,
        chartData: this.getChartData(item)
      };

      if (item.almacen && item.almacen.id) {
        const almacenId = item.almacen.id;
        const objeto2Encontrado = this.campData.find(obj => obj.id_almacen === almacenId);

        if (objeto2Encontrado) {
          updatedItem.campanyasPendientes = objeto2Encontrado.pendientes;
        }
      }

      return updatedItem;
    });

    return resultado;
  }





}
